
import { albionOfficialEcSiteConfig, lineMembersCardSiteConfig, albionCardEcSiteConfig } from '@baseConfig'

/**
/* LINE認証後リダイレクト先を定義
 * @class AlbionIDSite
 */
export class AlbionIDSite {
    /** @access private @type {Array[AlbionIDSite]} */
    static _values = new Array()

    static ALBION_OFFICIAL_EC = new AlbionIDSite('3AA00001', 'ALBION公式EC', albionOfficialEcSiteConfig)
    static LINE_MEMBERS_CARD = new AlbionIDSite('ATOS000001', 'LINE会員証', lineMembersCardSiteConfig)
    static ALBION_CARD = new AlbionIDSite('ATOS000002', 'ALBIONカード', albionCardEcSiteConfig)

    /**
     * constructor AlbionIDSite
     * @constructor
     * @param {string} provisionShopCode
     * @param {string} siteName
     */
    constructor(provisionShopCode, siteName, config) {
        this.provisionShopCode = provisionShopCode
        this.siteName = siteName
        this.config = config
        AlbionIDSite._values.push(this)
    }

    /**
     * find provisionShopCode
     * @param {string} provisionShopCode
     * @returns {Sex|undefined}
     */
    static findByProvisionShopCode(provisionShopCode) {
        return AlbionIDSite._values.find((site) => site.provisionShopCode === provisionShopCode)
    }
}
